"use strict";

(function () {
    const state = new (function () {
        this.requiredOptions = [...document.querySelectorAll(".cart_required_attr")];
        this.requestNoshi = false;
        this.requestWoodWriting = false;
        this.formValid = false;
        this.validDelivery = true;
        this.woodInputsValid = false;
    })();
    
    const cartForm = document.querySelector("form#cart");
    const checkoutButton = document.getElementById("checkout");
    const errorAnchor1 = document.getElementById("error-anchor1");
    const errorAnchor2 = document.getElementById("error-anchor2");
    const errorAnchor3 = document.getElementById("error-anchor3");
    const cartEmptyMsg = document.querySelector(".cart_empty_msg");
    const itemsSection = document.querySelector(".item_info_top");

    const cartRenderSections = ["sk-cart-items-section", "sk-cart-bubble-section", "sk-cart-total-section"];
    const cartTargetElements = [document.querySelector(".item_info_top"), document.querySelector(".cart_icon_container"), document.querySelector(".cart_total")];

    const cartOptions = document.getElementById("cart-options");
    const haisouContainer = document.getElementById("haisosm");
    const deliveryError = document.getElementById('delivery-error');
    const noshiSection = document.getElementById("noshi-section");
    const woodWritingSection = document.getElementById("woodwriting-section");
    const woodWritingInputs = [...document.querySelectorAll(".cart_woodwriting_attr")];
    const disabledNoshiOptions = document.getElementById('disabled-noshi-options');
    const disabledWoodWritingOptions = document.getElementById('disabled-woodwriting-options');
    const noshiWritingTop = document.querySelector('[name="attributes[表書き(上段)]"]');

    const woodWritingQtyContainer = document.querySelector('.wood-writing-qty');
    const woodWritingConfirm = document.querySelector(".wood-writing-qty__confirm-button");

    const noshiTypeWriting = [
                              ['御礼(蝶結び)','御礼'],
                              ['御祝(蝶結び)','御祝'],
                              ['退職御祝(蝶結び)','退職御祝'],
                              ['誕生日御祝(蝶結び)','誕生日御祝'],
                              ['還暦御祝(蝶結び)','還暦御祝'],
                              ['古希御祝(蝶結び)','古希御祝'],
                              ['喜寿御祝(蝶結び)','喜寿御祝'],
                              ['傘寿御祝(蝶結び)','傘寿御祝'],
                              ['米寿御祝(蝶結び)','米寿御祝'],
                              ['新築御祝(蝶結び)','新築御祝'],
                              ['結婚記念日(蝶結び)','金婚式御祝'],
                              ['結婚御祝（結び切り)','御結婚御祝'],
                              ['結婚内祝（結び切り)','内祝'],
                              ['出産内祝(蝶結び)','内祝'],
                              ['快気祝（結び切り)','快気祝'],
                              ['無地(蝶結び)',''],
                              ['無地（結び切り)',''],
                              ['弔辞（かけ紙)','志']
                            ];

    function renderCartSections(options) {
        const { variantId, lineIndex, itemQty, sectionsArr, targetElArr, endpoint } = options;

        let sectionsString = sectionsArr.map(section => `"${section}"`).join(',');
    
        let body = '';
        if (endpoint === 'add') {
            // If variantId is provided, prepare the body to add the product to the cart
            body = `{"id":"${variantId}", "quantity":"${itemQty}","sections":[${sectionsString}], "sections_url":"/cart"}`;
        } else if (endpoint === 'change') {
            // If lineIndex is provided, prepare the body to update the cart quantity
            body = `{"line":"${lineIndex}", "quantity":"${itemQty}","sections":[${sectionsString}], "sections_url":"/cart"}`;
        }
    
        const config = {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: `application/json` },
        };
    
        const url = endpoint === 'add' ? "/cart/add.js" : "/cart/change.js"; // Choose the endpoint based on the action
    
        fetch(url, { ...config, body })
            .then(response => response.text())
            .then(state => {
                const parsedState = JSON.parse(state);
                targetElArr.forEach((targetEl, i) => {
                    targetEl.innerHTML = parsedState.sections[sectionsArr[i]];
                });
                if (itemQty === 0 && lineIndex !== undefined) {

                    removewoodWritingItem(variantId);
                }
                checkAccessory();
            }).catch(error => { console.error(error) });
    }
    

    function addQuantity(qtyButton) {
        if (!qtyButton.classList.contains("plus_btn")) return;

        const lineIndex = qtyButton.dataset.index;
        const currentItemQty = qtyButton.dataset.qty;
        const maxQty = qtyButton.dataset.maxQty;
        const variantId = qtyButton.dataset.variantId;
        const newItemQty = Number(qtyButton.dataset.qty) + 1;
        const maxErrorMsg = document.querySelector(`.error__message[data-index="${lineIndex}"]`);

        if (currentItemQty === maxQty) {
            maxErrorMsg.classList.remove("hide_error");
        }

        if (currentItemQty != maxQty) {
            renderCartSections({variantId: variantId, lineIndex: lineIndex, itemQty: newItemQty, sectionsArr: cartRenderSections, targetElArr: cartTargetElements, endpoint:'change'});
        }
    }

    function subtractQuantity(qtyButton) {
        if (!qtyButton.classList.contains("minus_btn")) return;

        const cartQty = Number(qtyButton.dataset.cartQty);
        const lineIndex = qtyButton.dataset.index;
        const variantId = qtyButton.dataset.variantId;
        const newItemQty = Number(qtyButton.dataset.qty) - 1;
        const emptyCart = cartQty === 1;

        renderCartSections({variantId: variantId, lineIndex: lineIndex, itemQty: newItemQty, sectionsArr: cartRenderSections, targetElArr: cartTargetElements, endpoint:'change'});

        if (variantId == '43687696335001' && newItemQty < 1) { //有料アクセサリーボックスが0のときは、チェックボックスを外す
          const accessaryBoxCHK = document.getElementById("request-accessorybox");
          accessaryBoxCHK.checked = false;
          //const accessaryBoxTXT = document.querySelectorAll(".not-accesarybox");
          //accessaryBoxTXT.forEach(element => {
          //  element.remove();
          //});
          //const accessaryItemBox = document.querySelectorAll('.not-accesaryItem');
          //accessaryItemBox.forEach(element => {
          //  element.classList.remove('not-accesaryItem');
          //});
          checkAccessory();
        }
      
        if (emptyCart) {
            cartForm.remove();
            cartEmptyMsg.classList.remove("hide_error");
        }
    }

    function quantitySelectHandler(qtyButton) {
        addQuantity(qtyButton);
        subtractQuantity(qtyButton);
    }

    function checkFormValidity() {
        state.formValid = true; 

        for (const [i, el] of state.requiredOptions.entries()) {
            if (state.requestNoshi === false && el.classList.contains("cart_noshi_attr")) continue;
            if (state.requestWoodWriting === false && el.classList.contains("cart_woodwriting_attr")) continue;

            const validity = el.value ?? el.value.trim() != '' ? true : false;

            if (!validity || state.validDelivery === false) {
                state.formValid = false;
                cartForm.addEventListener("submit", preventSubmit);
            }
        }

        if (state.formValid) {
            cartForm.removeEventListener("submit", preventSubmit);
        }
    }

    function renderErrors() {
        
        for (const [i, el] of state.requiredOptions.entries()) {

           const validity = el.value ?? el.value.trim() != '' ? true : false;
            if (!validity) {
                const cartOption = el.closest("[data-cart-option]");
                const optionError = cartOption.querySelector(".error__message");
                optionError.classList.remove("hide_error");
            }

        }

        if (!state.formValid){

            if (state.requestWoodWriting && state.woodInputsValid === false) {
                errorAnchor2.scrollIntoView({block: "start"}); 
            } else if (state.validDelivery === false){
                errorAnchor3.scrollIntoView({block: "start"}); 
            } else{
                errorAnchor1.scrollIntoView({block: "start"}); 
            }

        }


    }

    function hideError(el) {
        const cartOption = el.closest("[data-cart-option]");
        const optionError = cartOption.querySelector(".error__message");

        if (!optionError) return;
        optionError.classList.add("hide_error");
    }

    function enableNoshiOptions() {

        disabledNoshiOptions.remove();

    }

    function disableNoshiOptions() {

        cartForm.append(disabledNoshiOptions);

    }


    function enableWoodWritingOptions() {

        disabledWoodWritingOptions.remove();

    }

    function disableWoodWritingOptions() {

        cartForm.append(disabledWoodWritingOptions);

    }


    function setWoodenBoxOption(el) {
        const id = el.id;
        const cartAttrEl = document.getElementById('woodenbox-option-attr');
        const woodenBoxOption2 = document.getElementById("woodenbox-option2");
        const woodenBoxOption2Count = document.getElementById('woodenbox-option2-count');

        switch (id) {
            case "woodenbox-option1":
                cartAttrEl.value = el.dataset.optionValue;
                woodenBoxOption2Count.setAttribute("disabled", "disabled");
                break;

            case "woodenbox-option2":
                cartAttrEl.value = el.dataset.optionValue + woodenBoxOption2Count.value;
                woodenBoxOption2Count.removeAttribute("disabled");
                break;

            case "woodenbox-option2-count":
                cartAttrEl.value = woodenBoxOption2.dataset.optionValue + "-" + el.value;
                break;

            default:
                return;
        }

        hideError(el);
        checkFormValidity();
    }

    function setRequestNoshiOption(el) {
        const id = el.id;
        const cartAttrEl = document.getElementById(`${id}-attr`);
        const isChecked = el.checked;

        if (isChecked) {
            noshiSection.style.display = "block";
            cartAttrEl.value = "希望";
            enableNoshiOptions();
            state.requestNoshi = true;
            hideError(el);

        }

        if (!isChecked) {
            noshiSection.style.display = "none";
            cartAttrEl.value = "";
            disableNoshiOptions();
            state.requestNoshi = false;

        }
        checkFormValidity();
        
    }

    function setRequestWoodWritingOption(el) {      
        const id = el.id;
        const cartAttrEl = document.getElementById(`${id}-attr`);
        const isChecked = el.checked;

        if (isChecked) {
            woodWritingSection.style.display = "block";
            cartAttrEl.value = "希望";
            enableWoodWritingOptions();
            state.requestWoodWriting = true;
            hideError(el);
            deliveryCheckHandler();
        }

        if (!isChecked) {
            woodWritingSection.style.display = "none";
            cartAttrEl.value = "";
            disableWoodWritingOptions();
            state.requestWoodWriting = false;
            deliveryError.classList.add('hide_error');
            state.validDelivery = true;
            resetBoxWriting();
        }
        checkFormValidity();
        
    }

    function setWoodWritingOption(el) {
        state.woodInputsValid = true;

        for(const woodInput of woodWritingInputs) {
            if (woodInput.value.trim() === '') {
                state.woodInputsValid = false;
                break;
            }
        }
        checkFormValidity();

        if (!state.woodInputsValid) return;
        hideError(el);
    }

    function setNoshiTypeWriting(el) {
     const writingArr = noshiTypeWriting.find(noshiWriting => noshiWriting[0] === el.value);
     noshiWritingTop.value = writingArr[1];
        hideError(el);
        checkFormValidity();
    }

    function setNoshiStyleOption(el) {
        if (el.type === 'textarea') return;
        const cartAttrEl = document.getElementById('noshi-style-attr');
        cartAttrEl.value = el.dataset.optionValue;
        hideError(el);
        checkFormValidity();
    }

    function setBagCatalogOption(el) {
        const id = el.id;
        const isChecked = el.checked;
        const cartAttrEl = document.getElementById(`${id}-attr`);

        if (isChecked) {
            cartAttrEl.value = "希望";
        }

        if (!isChecked) {
            cartAttrEl.value = "";
        }
    }

    function cartOptionsHandler(e) {
        const el = e.target;
        const cartOption = el.closest("[data-cart-option]").dataset.cartOption;

        if (!el) return;

        switch (cartOption) {
            case "request-noshi":
                setRequestNoshiOption(el);
                break;

            case "request-woodwriting":
                setRequestWoodWritingOption(el);
                break;    

            case "woodwriting":
                setWoodWritingOption(el);
                break;        

            case "bag-catalog":
                setBagCatalogOption(el);
                break;

            case "woodenbox":
                setWoodenBoxOption(el);
                break;

            case "noshi-details":
                setNoshiStyleOption(el);
                break;

            case "noshi-type":
                setNoshiTypeWriting(el);
                break;

            case "woodwriting-quantity":
                break;

            default:
                hideError(el);
                checkFormValidity();
        }
    }

    const watchHaisou = function () { 
        if (!haisouContainer) return;
        const config = { 
            childList: true, 
            subtree: true, 
        }; 
        const checkForHaisou = function (mutationsList, observer) { 
            for (const mutation of mutationsList) { 
                if (mutation.type === "childList") { 

                   const haisouDatePicker = document.querySelector(`#haisoShippingdate`) ?? document.querySelector(`#haisosagawashippingdate`); 

                    HaisoJquery(haisouDatePicker)
                    .on("input change", function (e) { 
                        deliveryCheckHandler(e.target)
                    }); 
                } 
                observer.disconnect(); 
            } 
        }; 
        const observer = new MutationObserver(checkForHaisou); 
        observer.observe(haisouContainer, config); 
    }; 
    watchHaisou(); 

    function dateDiff(firstDate, secondDate) {
        // Take the difference between the dates and divide by milliseconds per day.
        // Round to nearest whole number to deal with DST.
        return Math.round((secondDate-firstDate)/(1000*60*60*24));
    }
    

    function deliveryCheckHandler (haisouDatePicker) {

        const datePicker = !haisouDatePicker ? document.querySelector(`#haisoShippingdate`) ?? document.querySelector(`#haisosagawashippingdate`) : haisouDatePicker;

        if (state.requestWoodWriting != true || !datePicker ) return;

        const today = new Date();
        const haisouDateString = datePicker.value.trim().slice(0, datePicker.value.indexOf(` `));

        if (!haisouDateString) {
            deliveryError.classList.add('hide_error');
            state.validDelivery = true;
            checkFormValidity();
            return;
        }

        const selectedDate = new Date (haisouDateString);
        const dateGap = dateDiff(today, selectedDate);

      if (dateGap < 28) {
            deliveryError.classList.remove('hide_error');
            state.validDelivery = false;
            checkFormValidity()
        }

        if (dateGap >= 28) {
            deliveryError.classList.add('hide_error');
            state.validDelivery = true;
            checkFormValidity()
        }

    }

    function preventSubmit(event) {
        renderErrors();
        event.preventDefault();
    }


  function addwoodWritingItemInputs(woodWritingItem) {
    const allSets = woodWritingItem.querySelectorAll('.wood-writing-item__inputs');
    const newSetNumber = allSets.length + 1; // Since it's 0-indexed
    const variantId = woodWritingItem.getAttribute('data-wood-writing-item');
    const buttonContainer = woodWritingItem.querySelector('.wood-writing-item__button-container');
    
    const inputSetHTML = `
      <div class="wood-writing-item__inputs">
        <div class="wood-writing-item__input">
          <input type="number" id="${variantId}-wood-writing-input-${newSetNumber}-1" value="1" min="1" max="8"/>
          <label for="${variantId}-wood-writing-input-${newSetNumber}-1">個用箱に</label>
        </div>
        <div class="wood-writing-item__input">
          <input type="number" id="${variantId}-wood-writing-input-${newSetNumber}-2" value="1" min="1"/>
          <label for="${variantId}-wood-writing-input-${newSetNumber}-2">件</label>
        </div>
        <div class="wood-writing-item__delete-button-container">
        <button type="button" class="wood-writing-item__delete-button">削除</button>
      </div>
      </div>`;

    buttonContainer.insertAdjacentHTML('beforebegin', inputSetHTML);
    checkWoodWritingInputs();
  }

  function woodWritingQtyBtnsHandler(event) {
    const woodWritingItem = event.target.closest('.wood-writing-item');
    if (!woodWritingItem) return; // Click wasn't within a wood-writing-item

    if (event.target.matches('.wood-writing-item__add-button')) {
      addwoodWritingItemInputs(woodWritingItem);
    } else if (event.target.matches('.wood-writing-item__delete-button')) {
      const inputSet = event.target.closest('.wood-writing-item__inputs');
      if(inputSet) {
        woodWritingItem.removeChild(inputSet);
        checkWoodWritingInputs();
      }
    }
  }

  function removewoodWritingItem(matchingVariantId) {

        const woodWritingItem = document.querySelector(`.wood-writing-item[data-wood-writing-item="${matchingVariantId}"]`);   
        if(woodWritingItem) {
            woodWritingItem.remove();
        }
    
  }
  
function removeBoxWriting() {

    const boxWriting = document.querySelector('div[data-cart-item="43687704297625"]');

    if (!boxWriting) return;

        const lineIndex = boxWriting.getAttribute('data-line-index');
        renderCartSections({
            variantId: '43687704297625',
            lineIndex: lineIndex, 
            itemQty: 0, 
            sectionsArr: cartRenderSections, 
            targetElArr: cartTargetElements, 
            endpoint: 'change'
        });
}



/* 
woodWritingConfirm.addEventListener("click", function() {
    
    
    
    renderCartSections({
        variantId: "43687704297625",
        itemQty: 1,
        sectionsArr: cartRenderSections,
        targetElArr: cartTargetElements
    });
});
 */

function disableWoodWritingQty() {

    const elements = woodWritingQtyContainer.querySelectorAll('button, input');

    elements.forEach(el => {
        // Skip if it's the confirm button
        if (!el.classList.contains('wood-writing-qty__confirm-button')) {
            el.setAttribute('disabled', true);
        }
    });
}

function enableWoodWritingQty() {
    const elements = woodWritingQtyContainer.querySelectorAll('button, input');

    elements.forEach(el => {
        // Skip if it's the confirm button
        if (!el.classList.contains('wood-writing-qty__confirm-button')) {
            el.removeAttribute('disabled');
        }
    });
}


/* const woodWritingConfirm = document.querySelector(".wood-writing-qty__confirm-button");
function confirmWoodWritingQty(e) {
    const button = e.target;

    if (button.getAttribute('data-confirmed') === 'false') {
        button.setAttribute('data-confirmed', 'true');
        button.textContent = '変更';
        disableWoodWritingQty();
        hideError(button);

        const woodWritingItems = document.querySelectorAll('.wood-writing-item');
        let finalString = '';
        let totalWritingQty = 0;

        woodWritingItems.forEach(item => {
            const productName = item.querySelector('.wood-writing-item__title').textContent.trim();
            const inputs = item.querySelectorAll('.wood-writing-item__inputs input');

            let inputDetails = '';
            for (let i = 0; i < inputs.length; i += 2) {
                const boxQuantity = inputs[i].value; 
                const writingQuantity = inputs[i + 1].value; 

                // Add up the writing quantities to totalWritingQty
                totalWritingQty += parseInt(writingQuantity, 10);

                inputDetails += `${boxQuantity}個用箱に${writingQuantity}件`;
                if (i < inputs.length - 2) {
                    inputDetails += '」「';
                }
            }

            finalString += `${productName}「${inputDetails}」`;
        });

        // Pass the total quantity of writings to the renderCartSections function

        renderCartSections({
            variantId: "43687704297625",
            itemQty: totalWritingQty,
            sectionsArr: cartRenderSections,
            targetElArr: cartTargetElements,
            endpoint: 'add'
        });

        document.getElementById('wood-writing-qty-attr').value = finalString;
    } else {
        button.setAttribute('data-confirmed', 'false');
        button.textContent = '確定';
        enableWoodWritingQty();
        document.getElementById('wood-writing-qty-attr').value = '';
        removeBoxWriting();
    }

    for(const woodInput of woodWritingInputs) {
        if (woodInput.value.trim() === '') {
            state.woodInputsValid = false;
            break;
        }
    }
    checkFormValidity();
}
*/

function resetBoxWriting() {
    woodWritingConfirm.setAttribute('data-confirmed', 'false');
    woodWritingConfirm.textContent = '確定する';
    enableWoodWritingQty();
    document.getElementById('wood-writing-qty-attr').value = '';
    removeBoxWriting();
}

function checkWoodWritingInputs() {

    // Check if there are any 'wood-writing-item__inputs' within 'wood-writing-qty'
    const inputs = woodWritingQtyContainer.querySelectorAll('.wood-writing-item__inputs');

    // If there are inputs, remove the 'disabled' attribute from the confirm button
    // otherwise, add the 'disabled' attribute
    if (inputs.length > 0) {
        woodWritingConfirm.removeAttribute('disabled');
    } else {
        woodWritingConfirm.setAttribute('disabled', '');
    }
}

function confirmWoodWritingQty(e) {
    const button = e.target;

    if (button.getAttribute('data-confirmed') === 'false') {
        button.setAttribute('data-confirmed', 'true');
        button.textContent = '変更する';
        disableWoodWritingQty();
        hideError(button);
        const woodWritingItems = document.querySelectorAll('.wood-writing-item');
        let finalString = '';
        let totalWritingQty = 0;

        woodWritingItems.forEach(item => {
            const productName = item.querySelector('.wood-writing-item__title').textContent.trim();
            const inputs = item.querySelectorAll('.wood-writing-item__inputs input');

            let inputDetails = '';
            if (inputs.length > 0) {
                for (let i = 0; i < inputs.length; i += 2) {
                    const boxQuantity = inputs[i].value; 
                    const writingQuantity = inputs[i + 1].value; 

                    totalWritingQty += parseInt(writingQuantity, 10);
                    inputDetails += `${boxQuantity}個用箱に${writingQuantity}件`;
                    if (i < inputs.length - 2) {
                        inputDetails += '」「';
                    }
                }
            } else {
                // If there are no inputs, append "無し"
                inputDetails = '無し';
            }

            finalString += `${productName}「${inputDetails}」`;
        });

        renderCartSections({
            variantId: "43687704297625",
            itemQty: totalWritingQty,
            sectionsArr: cartRenderSections,
            targetElArr: cartTargetElements,
            endpoint: 'add'
        });

        document.getElementById('wood-writing-qty-attr').value = finalString;
    } else {
        button.setAttribute('data-confirmed', 'false');
        button.textContent = '確定する';
        enableWoodWritingQty();
        document.getElementById('wood-writing-qty-attr').value = '';
        removeBoxWriting();
    }

    for(const woodInput of woodWritingInputs) {
        if (woodInput.value.trim() === '') {
            state.woodInputsValid = false;
            break;
        }
    }
    checkFormValidity();

}

function removeAccessoryBox() {
    const accessoryBox = document.querySelector('div[data-cart-item="43687696335001"]');
    if (!accessoryBox) return;
    const lineIndex = accessoryBox.getAttribute('data-line-index');
    renderCartSections({
        variantId: '43687696335001',
        lineIndex: lineIndex, 
        itemQty: 0, 
        sectionsArr: cartRenderSections, 
        targetElArr: cartTargetElements, 
        endpoint: 'change'
    });
}
  
function confirmAccessoryBoxQty(e) {
  const accessoryCHK = e.target;
  if (accessoryCHK.checked) {
      renderCartSections({
          variantId: "43687696335001",
          itemQty: 1,
          sectionsArr: cartRenderSections,
          targetElArr: cartTargetElements,
          endpoint: 'add'
      });
      const targetElement = document.getElementById('shopify-section-sk-cart-items-section');
      const offsetTop = targetElement.offsetTop-100;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }else{
    document.getElementById('request-accessorybox-attr').value = '';
    removeAccessoryBox();
  }
}

  
  function init() {

        if (!cartForm) return;

        removeBoxWriting();
        
        const accessaryBoxCHK = document.getElementById("request-accessorybox");
        accessaryBoxCHK.addEventListener('click', function(e) {
            confirmAccessoryBoxQty(e);
        });
        checkAccessory();
      
        woodWritingConfirm.addEventListener('click', function(e) {
            confirmWoodWritingQty(e);
        });
        
        itemsSection.addEventListener("click", function (e) {
            quantitySelectHandler(e.target);
        });

        cartOptions.addEventListener("input", function (e) {
            cartOptionsHandler(e);
        });

        checkoutButton.addEventListener("click", function (e) {
            renderErrors();
        });

        woodWritingQtyContainer.addEventListener('click', woodWritingQtyBtnsHandler);

        cartForm.addEventListener("submit", preventSubmit);
    }

    async function checkAccessory() {
      let chkAcce = 0;
      let chkNotAcce = 0;
      let chkAcceBox = 0;
      let chkOnlyBox = 0;
      try {
        const cartResponse = await fetch('/cart.js'); // カート情報を取得
        const cart = await cartResponse.json();
    
        // 各商品のデータを取得して判定
        for (const item of cart.items) {
          const productResponse = await fetch(`/products/${item.handle}.js`);
          const product = await productResponse.json();
          if (product.title === "有料アクセサリーボックス") {
            chkAcceBox = 1;
          }
          if (product.tags.some(tag => tag.includes("有料アクセサリーボックス"))) {
            chkAcce = 1; // アクセサリーの場合
          } else {
            chkNotAcce = 1; // アクセサリー以外の場合
          }
          if (product.tags.some(tag => tag.includes("専用箱"))) {
            chkOnlyBox = 1; // 専用箱がある場合
          }
        }

        const accessaryBoxTXT = document.querySelectorAll(".not-accesarybox");
        accessaryBoxTXT.forEach(element => {
          element.remove();
        });
        const accessaryItemBox = document.querySelectorAll('.not-accesaryItem');
        accessaryItemBox.forEach(element => {
          element.classList.remove('not-accesaryItem');
        });

        if (chkNotAcce === 1 && chkAcce === 0) { //アクセサリー以外の商品のみ
          //有料アクセサリーボックス
          const check_accessarybox = document.querySelectorAll('input[name="request-accessorybox"]');
          check_accessarybox.forEach(check => {
              check.checked = false; // チェックを外す
              check.disabled = true; // 無効化する
          });
          const accessaryboxDiv = document.querySelector('div[data-cart-option="accessorybox"]');
          if (accessaryboxDiv) {
            const accessaryboxItemDetail = accessaryboxDiv.querySelector('.item_deta_r');            
            if (accessaryboxItemDetail) {
                if (accessaryboxItemDetail) {
                    accessaryboxItemDetail.innerHTML += '<p class="deta_text red-text not-accesarybox" style="margin-top: 1rem;">アクセサリー商品を購入される場合のみ選択できます。</p>';
                }
            }
            accessaryboxDiv.classList.add('not-accesaryItem');
          }
          
          console.log('アクセサリー以外があります。');
        }
        if (chkAcce === 1 && chkNotAcce === 0) { //アクセサリーの商品のみ
          //桐箱
          const radio_woodbox = document.querySelectorAll('input[name="select-woodenbox"]');
          radio_woodbox.forEach(radio => {
              radio.checked = false; // チェックを外す
              radio.disabled = true; // 無効化する
          });
          const woodenboxDiv = document.querySelector('div[data-cart-option="woodenbox"]');
          if (woodenboxDiv) {
            const woodenboxItemDetail = woodenboxDiv.querySelector('.item_deta_r');            
            if (woodenboxItemDetail) {
                const woodenboxformBox = woodenboxItemDetail.querySelector('.form_box');                
                if (woodenboxformBox) {
                    woodenboxformBox.innerHTML += '<p class="deta_text red-text not-accesarybox" style="margin-top: 1rem;">アクセサリー商品は桐箱を選択できません。</p>';
                }
            }
            woodenboxDiv.classList.add('not-accesaryItem');
          }
          
          //特注箱書き
          const woodwritingCHK = document.getElementById("request-woodwriting");
          woodwritingCHK.checked = false; // チェックを外す
          woodwritingCHK.disabled = true; // 無効化する
          setRequestWoodWritingOption(woodwritingCHK);
          const woodwritingDiv = document.querySelector('div[data-cart-option="request-woodwriting"]');
          if (woodwritingDiv) {
            const woodwritingItemDetail = woodwritingDiv.querySelector('.item_deta_r');            
            if (woodwritingItemDetail) {
                  woodwritingItemDetail.innerHTML += '<p class="deta_text red-text not-accesarybox" style="margin-top: 1rem;">アクセサリー商品は特注箱書きを選択できません。</p>';
            }
            woodwritingDiv.classList.add('not-accesaryItem');
          }

          //熨斗
          if (chkAcceBox !== 1 && chkOnlyBox === 0){
            const noshiCHK = document.getElementById("request-noshi");
            noshiCHK.checked = false; // チェックを外す
            noshiCHK.disabled = true; // 無効化する
            const noshiDiv = document.querySelector('div[data-cart-option="request-noshi"]');
            if (noshiDiv) {
              const noshiItemDetail = noshiDiv.querySelector('.item_deta_r');            
              if (noshiItemDetail) {
                    noshiItemDetail.innerHTML += '<p class="deta_text red-text not-accesarybox" style="margin-top: 1rem;">アクセサリー商品は有料箱を購入いただいた場合のみ熨斗がつけれます。</p>';
              }
              noshiDiv.classList.add('not-accesaryItem');
            }
          }else{
            const noshiCHK = document.getElementById("request-noshi");
            noshiCHK.disabled = false;
          }
          console.log('アクセサリーのみです。');
        }
      } catch (error) {
        console.error("エラーが発生しました:", error);
      }
    }

    init();
})();